<div class="flex">
	<a mat-mini-fab color="primary" class="box_hover" (click)="twitter()" matTooltip="Compartir en Twitter">
		<mat-icon svgIcon="twitter"></mat-icon>
	</a>

	<a mat-mini-fab color="primary" class="box_hover" (click)="garbageSocialMedia()" matTooltip="Compartir en Facebook">
		<mat-icon svgIcon="facebook"></mat-icon>
	</a>

	<a mat-mini-fab color="primary" class="box_hover" (click)="whatsApp()" matTooltip="Compartir en WhatsApp">
		<mat-icon svgIcon="whatsapp"></mat-icon>
	</a>
</div>